import { EyeIcon, PencilIcon, TrashIcon } from '@heroicons/react/24/outline';
import { IDocumentResource } from '../../types/Resource/DocumentResource';
import { useClipboardCopy } from '../../hooks/useClipboardCopy';

interface FaultResourcesProps {
  resources: IDocumentResource[];
  onEdit?: (index: number) => void;
  onRemove?: (index: number) => void;
  showActions?: boolean;
}

export function FaultResources({
  resources,
  onEdit,
  onRemove,
  showActions = false,
}: FaultResourcesProps) {
  const { CopyToClipboardButton } = useClipboardCopy();

  return resources.length === 0 ? (
    <p className="text-sm text-gray-500 dark:text-gray-400">
      No resources available for this fault.
    </p>
  ) : (
    <div className="mt-6 block overflow-x-auto overflow-y-hidden">
      <table className="min-w-full table border border-primary/40 divide-y divide-primary dark:border-primary">
        <thead className="bg-primary/40">
          <tr>
            <th className="px-3 py-3 text-left text-sm font-semibold">
              Resource Title
            </th>
            <th className="px-3 py-3 text-left text-sm font-semibold">URL</th>
            <th className="px-3 py-3 text-left text-sm font-semibold">
              Actions
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-primary/40">
          {resources.map((resource, rowIndex) => (
            <tr
              key={rowIndex}
              className={rowIndex % 2 !== 0 ? 'bg-primary/10' : ''}
            >
              <td className="whitespace-nowrap px-3 py-4 text-sm font-medium">
                {resource.title}
              </td>
              <td className="px-3 py-4 text-sm text-blue-600 dark:text-blue-400">
                <a
                  href={resource.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:underline"
                >
                  {resource.url}
                </a>
              </td>
              <td className="px-3 py-4 text-sm">
                <div className="flex space-x-2">
                  <EyeIcon
                    className="w-5 h-5 opacity-70 hover:opacity-100 hover:cursor-pointer"
                    onClick={() =>
                      window.open(resource.url, '_blank', 'noopener,noreferrer')
                    }
                    title="View resource"
                  />
                  <CopyToClipboardButton iconOnly copyText={resource.url} />
                  {showActions && onEdit && (
                    <PencilIcon
                      className="w-5 h-5 opacity-70 hover:opacity-100 hover:cursor-pointer"
                      onClick={() => onEdit(rowIndex)}
                      title="Edit resource"
                    />
                  )}
                  {showActions && onRemove && (
                    <TrashIcon
                      className="w-5 h-5 opacity-70 hover:opacity-100 hover:cursor-pointer"
                      onClick={() => onRemove(rowIndex)}
                      title="Remove resource"
                    />
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
